import React, { PureComponent } from 'react'
import {
  string, bool, number, node, shape, object, arrayOf,
  func,
} from 'prop-types'
import Form from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormStaticField from '@active/react-ui/FormStaticField'
import { Locale, withI18n } from '@active/react-utils/i18n'

import findOptionSettings from '../../../../../shared/utils/RemittanceOptionUtils'
import paymentMethodTypes, { paymentMethodPropType } from '../paymentMethodTypes'
import imgMap from '../imgs/imgMap'

import './PaymentMethodDetail.scss'

class ACHDetail extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,
    fields: shape({
      address: object.isRequired,
    }).isRequired,
    children: node.isRequired,

    remittanceOptions: arrayOf(shape({
      countryCode: string.isRequired,
      currencyCode: string.isRequired,
      remittanceOptionSettingList: arrayOf(shape({
        fieldType: string.isRequired,
        fieldName: string.isRequired,
        required: bool,
        listIndex: number.isRequired,
      })),
    })).isRequired,
    i18n: func.isRequired,
  }

  render() {
    const {
      children, paymentMethod, fields, remittanceOptions, i18n,
    } = this.props
    const info = paymentMethodTypes.convert(paymentMethod)

    const subFields = {
      ...fields,
      accountType: info.getSummaryData(i18n),
    }

    return (
      <div className="checkout-payments checkout__payment-detail checkout__ach-detail">
        <Form
          horizontal
          trimInput
          initialValues={subFields}
          className="form--vertical checkout__payment-detail--form checkout__ach-detail--form"
        >
          <FormGroup name="countryCode">
            <FormLabel><Locale id="passport.lib.components.achNumber.label.bankCountry" /></FormLabel>
            <FormStaticField />
          </FormGroup>
          <FormGroup name="currencyCode">
            <FormLabel><Locale id="passport.lib.components.achNumber.label.currency" /></FormLabel>
            <FormStaticField />
          </FormGroup>
          {
            findOptionSettings({ remittanceOptions, remittanceMethod: 'ACH', ...subFields })
              .filter(op => op.fieldType !== 'BRANCH_NAME') // Ignore BRANCH_NAME for now
              .map(os => (
                <FormGroup name={os.fieldType} key={`${os.fieldType}_FormGroup`}>
                  <FormLabel>
                    <Locale
                      /**
                       * passport.lib.components.achNumber.label.ACCOUNT_NUMBER
                       * passport.lib.components.achNumber.label.BANK_ACCOUNT_OWNER
                       * passport.lib.components.achNumber.label.BANK_NAME
                       * passport.lib.components.achNumber.label.IBAN
                       * passport.lib.components.achNumber.label.ROUTING_NUMBER
                       * passport.lib.components.achNumber.label.SWIFT_BIC
                       */
                      id={`passport.lib.components.achNumber.label.${os.fieldType}`}
                    />
                  </FormLabel>
                  <FormStaticField />
                </FormGroup>
              ))
          }
          {children}
        </Form>
      </div>
    )
  }
}

export default withI18n(ACHDetail)

const defaultIcon = [imgMap.ACH, 'ach']
export {
  defaultIcon,
}
